import React, { useMemo } from "react"

import styled from "styled-components"

import { spacing } from "@izettle/otto"

import { DialogSize, ModalSize } from "../../../enumerations"
import { Icon } from "../../icon"
import { ModalBase } from "../../modal/modal-base"
import { Text } from "../../text"

import { DialogProps } from "./types"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledIcon = styled(Icon)`
  text-align: center;
  font-size: 50px;
  margin-bottom: ${spacing.large};
`

export const Dialog: React.FC<DialogProps> = React.memo(
  ({ textCloseDialog, textContent, iconTitle, svgIcon, size, children, ...props }) => {
    const modalSize: ModalSize = useMemo(() => {
      switch (size) {
        case DialogSize.Small:
          return ModalSize.Small
        default:
          return ModalSize.Medium
      }
    }, [size])

    const content = useMemo(() => {
      const styledText = textContent && <Text.Regular>{textContent}</Text.Regular>
      const styledIcon = svgIcon && <StyledIcon title={iconTitle} svgIcon={svgIcon} />
      return (
        (textContent || svgIcon) && (
          <Content>
            {styledIcon}
            {styledText}
          </Content>
        )
      )
    }, [textContent])

    return (
      <ModalBase
        {...props}
        size={modalSize}
        isOutsideClickable
        textCloseModal={textCloseDialog}
        isMobileOverride={false}
        hideTextLabel
      >
        {content}
        {children}
      </ModalBase>
    )
  },
)
